import { Box, Typography } from "@mui/material";

import GrayPaper from "../../atoms/GrayPaper";
import Link from "../../atoms/mui/Link";
import DocumentationDownloadButton from "../../atoms/buttons/DocumentationDownloadButton";

import { useCachedDisplayData } from "../../../helpers/firebase";
import usePlatformLayoutContext from "../../../helpers/contexts/platformLayout";
import { isVisibleDocumentationFile } from "../../../helpers/smartUpload";

const FILING_TARGETS = {
  offices: { noun: "building", path: "dashboard/offices" },
  vehicles: { noun: "vehicle", path: "settings/vehicles" },
  vendors: { noun: "vendor", path: "dashboard/vendors" }
};

// The source document a Smart Upload activity was confirmed from, filed on
// its building, vehicle, or vendor (Design Intent 1.11). A no-entity filing
// (type: "transactions") already shows in this slideout's own uploader list,
// so only entity filings render here.
const SmartUploadFiledDocument = ({ transactionId, documentRef }) => {
  const { rootPath = "/platform/company" } = usePlatformLayoutContext() || {};
  const [filedDocuments] = useCachedDisplayData("documentation-files", [
    ["linkedTransactionIds", "array-contains", transactionId]
  ]);

  const filedDocument = (filedDocuments || [])
    .filter(isVisibleDocumentationFile)
    .find(
      ({ id, type }) =>
        type !== "transactions" &&
        (!documentRef?.documentation_file_id ||
          id === documentRef.documentation_file_id)
    );

  if (!filedDocument) {
    return null;
  }

  const { name, url, type, linkedDoc } = filedDocument;
  const target = FILING_TARGETS[type];
  const pageLabel = documentRef?.source_page
    ? ` · page ${documentRef.source_page}`
    : "";

  return (
    <GrayPaper>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="subtitle2">Source document</Typography>
          <Typography variant="body2">
            {name}
            {pageLabel}
          </Typography>
          {target && linkedDoc?.name && (
            <Link href={`${rootPath}/${target.path}`} color="primary">
              <Typography variant="caption">
                Filed on the {target.noun} {linkedDoc.name}
              </Typography>
            </Link>
          )}
        </Box>
        {url && <DocumentationDownloadButton name={name} url={url} />}
      </Box>
    </GrayPaper>
  );
};

export default SmartUploadFiledDocument;
